(() => {
  const finishOptionPattern = /finish|colour|color|metal|plating|acabamento|finitura/i;

  const classifyFinish = (label) => {
    const normalized = String(label || '').toLowerCase();
    if (/rose\s*gold|ros[eé]/i.test(normalized)) return 'rose-gold';
    if (/gold|18k|ouro|dourad/i.test(normalized)) return 'gold';
    if (/silver|prata|argento/i.test(normalized)) return 'silver';
    if (/black|nero|preto/i.test(normalized)) return 'black';
    return 'other';
  };

  const fallbackFinishFromTitle = (title) => {
    const value = String(title || '');
    if (/rose\s*gold/i.test(value)) return 'Rose Gold';
    if (/gold|18k|ouro|dourad/i.test(value)) return 'Gold';
    if (/silver|prata|argento/i.test(value)) return 'Silver';
    if (/black|nero|preto/i.test(value)) return 'Black';
    return '';
  };

  const enhanceCard = (card) => {
    if (!card || card.dataset.finishSwatchesReady === 'true') return;

    const variantDataNode = card.querySelector('[data-product-card-variants]');
    if (!variantDataNode) return;

    let data;
    try {
      data = JSON.parse(variantDataNode.textContent);
    } catch (error) {
      return;
    }

    const options = Array.isArray(data.options) ? data.options : [];
    const variants = Array.isArray(data.variants) ? data.variants : [];
    const finishIndex = options.findIndex((name) => finishOptionPattern.test(String(name || '')));
    const finishes = new Map();

    variants.forEach((variant) => {
      let label = '';

      if (finishIndex >= 0 && Array.isArray(variant.options)) {
        label = String(variant.options[finishIndex] || '').trim();
      }

      if (!label) label = fallbackFinishFromTitle(variant.title);
      if (!label || finishes.has(label)) return;

      finishes.set(label, variant);
    });

    if (finishes.size < 2) return;

    const row = document.createElement('div');
    row.className = 'balcone-product-card__finishes';
    row.setAttribute('aria-label', 'Available finishes');

    finishes.forEach((variant, label) => {
      const swatch = document.createElement('a');
      swatch.className = `balcone-product-card__finish balcone-product-card__finish--${classifyFinish(label)}`;
      const productUrl = String(data.url || card.querySelector('a[href]')?.getAttribute('href') || '');
      const separator = productUrl.includes('?') ? '&' : '?';
      swatch.href = variant.id ? `${productUrl}${separator}variant=${variant.id}` : productUrl;
      swatch.setAttribute('aria-label', `${label} finish`);
      swatch.title = label;
      swatch.dataset.finish = label;
      row.appendChild(swatch);
    });

    const price = card.querySelector('.balcone-product-card__price');
    const titleRow = card.querySelector('.balcone-product-card__title-row');
    const info = card.querySelector('.balcone-product-card__info');

    if (price) {
      price.before(row);
    } else if (titleRow) {
      titleRow.after(row);
    } else if (info) {
      info.appendChild(row);
    } else {
      return;
    }

    card.dataset.finishSwatchesReady = 'true';
  };

  const init = (root = document) => {
    if (root.matches?.('[data-balcone-product-card]')) enhanceCard(root);
    root.querySelectorAll?.('[data-balcone-product-card]').forEach(enhanceCard);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
